import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { SocialProofStrip } from './components/SocialProofStrip';
import { ImageMarquee } from './components/ImageMarquee';
import { DesignShowcase } from './components/DesignShowcase';
import { ProblemSection } from './components/ProblemSection';
import { OfferReveal } from './components/OfferReveal';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingCard } from './components/PricingCard';
import { AltaDemandaSection } from './components/AltaDemandaSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen font-sans selection:bg-brand-pink selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProofStrip data-id="element-4" />
        <ImageMarquee data-id="element-5" />
        <DesignShowcase data-id="element-6" />
        <ProblemSection data-id="element-7" />
        <OfferReveal data-id="element-8" />
        <TomosSection data-id="element-9" />
        <BonosSection data-id="element-10" />
        <div className="bg-brand-cream/30" data-id="element-11">
          <PricingCard data-id="element-12" />
        </div>
        <AltaDemandaSection data-id="element-13" />
        <TestimonialsSection data-id="element-14" />
        <GuaranteeSection data-id="element-15" />
        <FAQ data-id="element-16" />
        <FinalCTA data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
    </div>;
}